import { IconButton, Text, HStack } from '@genial/components';
import { Spacing, Color, Typography } from '@genial/design-tokens';
import { useNavigation } from '@react-navigation/native';
import React from 'react';

import { SignedInNavigationScreenNavigationProp } from '../../../../routes/types';

interface HeaderProps {
  isMobile: boolean;
}

export const Header: React.FC<HeaderProps> = ({ isMobile }) => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();

  const goBack = () => {
    navigate('TransactionFlow');
  };

  if (isMobile) {
    return (
      <HStack alignItems="center" justifyContent={'space-between'}>
        <HStack alignItems="center" space={Spacing['inline.xxxs']}>
          <IconButton
            testId="icon"
            icon="ArrowLeft"
            iconSize="xxs"
            p={0}
            backgroundColor="transparent"
            iconColor={Color['brand.primary.principal']}
            onPress={goBack}
          />
          <Text variant="bold" fontSize={Typography['fontsize.lg']} color="neutral.black">
            Posição detalhada
          </Text>
        </HStack>
      </HStack>
    );
  }

  return (
    <HStack alignItems="center" justifyContent="space-between">
      <HStack alignItems="center" space={Spacing['inline.xxxs']}>
        <IconButton
          icon="ArrowLeft"
          testId="return-button"
          shadow={3}
          variant="link"
          onPress={goBack}
          iconColor={Color['brand.tertiary.principal']}
          iconSize="xs"
        />
        <Text variant="regular" fontSize={Typography['fontsize.xxl']} color="neutral.black">
          Posição detalhada
        </Text>
      </HStack>
    </HStack>
  );
};
